import { PaymentStatus } from '@/api/enumerations';
import { HivePaymentData } from '@/api/financial/types';
import { Constants } from '@/constants/finance';
import { Box } from '@mui/material';
import { memo } from 'react';

import { DisabledActionButton } from '../../styles';
import ApproveDialog from '../ApproveDialog';
import InvoiceDialog from '../InvoiceDialog';
import RegisterPaymentDialog from '../RegisterPaymentDialog';

interface PaymentActionButtonProps {
  status: PaymentStatus;
  payment: HivePaymentData;
  updateData: () => void;
}

export type StatusStyle = {
  bg: string;
  color: string;
};

const getStatusStyles = (status: PaymentStatus): StatusStyle => {
  switch (status) {
    case PaymentStatus.PENDING:
      return { bg: '#FB923C', color: '#FFFFFF' };
    case PaymentStatus.APPROVED:
      return { bg: '#6366F1', color: '#FFFFFF' };
    case PaymentStatus.INVOICED:
      return { bg: '#1D9E75', color: '#FFFFFF' };
    case PaymentStatus.PAID:
      return { bg: '#EAECF0', color: '#707070' };
    default:
      return { bg: '#EAECF0', color: '#707070' };
  }
};

export const PaymentActionButton = memo(function PaymentActionButton({
  status,
  payment,
  updateData,
}: PaymentActionButtonProps): JSX.Element {
  const styles = getStatusStyles(status);

  const renderMainButton = (): JSX.Element => {
    switch (status) {
      case PaymentStatus.PENDING:
        return (
          <ApproveDialog
            paymentData={payment}
            styles={styles}
            updateData={updateData}
          />
        );
      case PaymentStatus.APPROVED:
        return (
          <InvoiceDialog
            paymentId={payment.id}
            styles={styles}
            updateData={updateData}
          />
        );
      case PaymentStatus.INVOICED:
        return (
          <RegisterPaymentDialog
            paymentId={payment.id}
            styles={styles}
            updateData={updateData}
          />
        );
      case PaymentStatus.PAID:
        return (
          <DisabledActionButton
            disabled
            bgcolor={styles.bg}
            textcolor={styles.color}
          >
            {Constants.paid}
          </DisabledActionButton>
        );
      default:
        return <Box />;
    }
  };

  return <>{renderMainButton()}</>;
});
